<template>
   <v-row>
        <v-col cols="6">
            <v-text-field
            @change="emitToParent"
            v-model="nama_alamat"
            :counter="100"
            label="Nama Alamat"
            outlined
            ></v-text-field>

            <mapsAutocomplete 
            :withmap="true"
            @marker-move="showSuggest"
            form_style="width:100%"
            map_style="width:100%; height:450px"
            :current_location="false"
            :center_map="{lat:-6.230,lng:106.744}"
            :markers="[{position:{lat:-6.230,lng:106.744}}]"
            map_type="terrain"
            style="width:100%"/>

        </v-col>

        <v-col cols="6">
            
            <v-alert
            v-if="this.suggest_alamat"
            dense
            outlined
            type="info"
            class="caption">Kami telah <strong>MENYIMPAN</strong> titik pada peta sebagai alamat anda, apakah anda ingin mengisikan <strong>{{this.suggest_alamat}}</strong> pada form alamat ?
                <v-btn @click="suggest_alamat=''" text icon color="red danger-1" x-small>
                <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-btn text icon color="success" @click="alamat=suggest_alamat" x-small>
                <v-icon>mdi-check</v-icon>
                </v-btn>
            </v-alert>
            <v-textarea
            :counter="191"
            v-model="alamat"
            rows="3"
            label="Alamat"
            outlined
            ></v-textarea>

            <v-autocomplete
            label="Negara"
            @change="emitToParent"
            v-model="country"
            :items="select_country"
            outlined
            ></v-autocomplete>

            <v-autocomplete
            label="Provinsi"
            @change="getCity"
            :return-object="true"
            itemText="nama"
            :items="select_province"
            v-model="province"
            outlined
            ></v-autocomplete>

            <v-autocomplete
            @change="getDistrict"
            label="Kabupaten/Kota"
            v-model="city"
            :return-object="true"
            itemText="nama"
            :items="select_city"    
            outlined
            ></v-autocomplete>

            <v-autocomplete
            @change="emitToParent"
            label="District"
            :items="select_district"
            :return-object="true"
            outlined
            itemText="nama"
            itemValue="id_kec"
            v-model="district"
            ></v-autocomplete>

            <v-text-field
            @change="emitToParent"
            label="Kode Pos"
            v-model="postcode"
            outlined
            ></v-text-field>

            <v-text-field
            @change="emitToParent"
            v-model="telephone_alamat"
            label="Telephone"
            :counter="20"
            outlined
            ></v-text-field>
        </v-col>
    </v-row>
</template>
<script>
/* eslint-disable */
import rules from "@/plugins/validation_rules.js";
import maps from "@/components/layouts/Maps.vue";
import mapsAutocomplete from "@/components/layouts/MapsAutocomplete.vue";
let context;
export default{
    name:"vendor.alamat.form",
    components:{
        maps,
        mapsAutocomplete
    },
    data:()=>{
        return{
            suggest_alamat:"",
            alamat:"",
            nama_alamat:"",
            coord:{},
            select_country:[
                {text:"Indonesia", value:"Indonesia"}
            ],
            select_province:[],
            select_city:[],
            select_district:[],
            country:"",
            province:"",
            city:"",
            district:"",
            postcode:"",
            telephone_alamat:""
        }
    },
    methods:{
        showSuggest(location){
            context.coord={
                lat:location.geometry.location.lat(),
                lng:location.geometry.location.lng()
            }
            context.suggest_alamat=location.formatted_address;
            context.emitToParent();
        },

        emitToParent(){
            let data ={
                country:context.country,
                province:context.province.nama,
                city:context.city.nama,
                district:context.district.nama,
                postcode:context.postcode,
                alamat:context.alamat,
                coord:context.coord,
                nama_alamat:context.nama_alamat,
                telephone_alamat:context.telephone_alamat
            };

            context.$emit("change_value",data);
        },
        getProvince(){
            context.$http
            .get("place/get?type=provinsi")
            .then(response=>{
                // console.log(response)
                context.select_province=response.data.data;
            })
            .catch(error=>{
                context.$notify({
                        group:"error",
                        title:"Error Notification",
                        text:"Terjadi kesalahan pada client"
                })
            })
        },
        getCity(){
            context.district="";
            context.$http
            .get("place/get?type=kabupaten&group="+context.province.id_prov)
            .then(response=>{
                context.select_city=response.data.data;
                context.emitToParent();
            })
            .catch(error=>{
                context.$notify({
                        group:"error",
                        title:"Error Notification",
                        text:"Terjadi kesalahan pada client"
                })
            })
        },
        getDistrict(){
            context.$http
            .get("place/get?type=kecamatan&group="+context.city.id_kab)
            .then(response=>{
                context.select_district=response.data.data;
                context.emitToParent();
            })
            .catch(error=>{
                context.$notify({
                        group:"error",
                        title:"Error Notification",
                        text:"Terjadi kesalahan pada client"
                })
            })
        }
    },

    watch: {
      datas: [],
      alamat:{
          handler(){
                context.emitToParent();
          }
      },
      options: {
        handler () {
         context.getData();
        },
        deep: true,
      },
    },
    async mounted (){
        context=this;
        context.country=context.select_country[0].value;
        context.getProvince();
       
    }
}
</script>